import Immutable from "immutable";
import { cloneDeep } from "lodash";
const populateEmployments = (profile, formData) => {
  if (profile.applicantInfo.workHistory && profile.applicantInfo.workHistory.length > 0) {
    profile.applicantInfo.workHistory.forEach((item) => {
      let emp = { title: item.jobTitle, employer: item.companyName };
      if (item.achievements && item.achievements !== undefined) {
        emp.description = item.achievements;
      }
      if (item.to && item.to !== undefined) {
        emp.endDate = item.to;
      }
      if (item.from && item.from !== undefined) {
        emp.startDate = item.from;
      }
      if (formData.employment !== undefined && formData.employment !== null) {
        formData.employment.push(emp);
      }
    });
  }
};

const convertToSkillObject = (skills) => {
    return skills.map((s) => s);
};

export const overridePopulateDataFromProfile = (formData, profile) => {
  if (profile.applicantInfo) {
    formData.firstName = profile.applicantInfo.firstName;
    formData.lastName = profile.applicantInfo.lastName;
    formData.email = profile.applicantInfo.emailAddress;
    formData.confirmEmail = profile.applicantInfo.emailAddress;
    formData.profileId = profile.id;
    if (
      (profile.applicantInfo.phoneNumber !== "" && formData.primaryContactNumber == null) ||
      formData.primaryContactNumber === ""
    ) {
      formData.primaryContactNumber = profile.applicantInfo.phoneNumber;
    } else if (
      (profile.applicantInfo.phoneNumber !== "" && formData.secondaryContactNumber == null) ||
      formData.secondaryContactNumber === ""
    ) {
      formData.secondaryContactNumber = profile.applicantInfo.phoneNumber;
    }
    if (profile.applicantInfo.skills && profile.applicantInfo.skills.length > 0) {
      formData.skills = JSON.stringify(convertToSkillObject(profile.applicantInfo.skills));
    }
    populateEmployments(profile, formData);
  }
  if (profile.cv && profile.cv != null && profile.cv.upload !== "") {
    formData.cv = profile.cv;
  }
  return formData;
};

export const setCountryValidation = (schema, formData) => {
  let makeRequired = "region";
  let makeRequiredUA = ["admin1Name", "admin1Code", "placeName", "postalCode"];

  // other countries
  if (formData.address && formData.address.countryCode !== "US" && formData.address.countryCode !== "AU") {
    // reset required
    makeRequiredUA.map((requiredProp) => {
      delete schema.properties.address.required[schema.properties.address.required.indexOf(requiredProp)];
    });

    // Set the region field to required
    if (schema.properties.address.required.indexOf(makeRequired) === -1) {
      schema.properties.address.required.push(makeRequired);
    }
    schema.properties.address.properties.region.minLength = 1;
    delete schema.properties.address.properties.admin1Name.not;
  } else {
    // US and AU
    makeRequiredUA.map((requiredProp, counter) => {
      if (schema.properties.address.required.indexOf(makeRequiredUA[counter]) === -1) {
        schema.properties.address.required.push(makeRequiredUA[counter]);
      }
    });
    let notDefault = {
      not: {
        pattern: ["Default"],
      },
    };
    schema.properties.address.properties.region.minLength = 0;
    schema.properties.address.properties.admin1Name = notDefault;

    // Copy address fields
    formData.address.locationCode =
      formData.address && formData.address.postalCode ? formData.address.postalCode : formData.address.locationCode;
    formData.address.region =
      formData.address && formData.address.placeName ? formData.address.placeName : formData.address.region;
  }

  //As we mark postalCode as required but we are not taking it value and we simplying mapping user locationcode user inputs to postalCode.
  if (formData.address.locationCode && formData.address.postalCode !== formData.address.locationCode) {
    formData.address.postalCode = formData.address.locationCode;
  }

  if (formData.address && formData.address.countryCode !== formData.address.countryCode) {
    if (typeof formData.address.region == "undefined") {
      formData.address.region = "";
    }
  }

  return {
    schema: schema,
    formData: formData,
  };
};

const setJobPreferences = (newFormData, candidate) => {
  if (candidate.jobStatusPreferences) {
    newFormData.candidate.jobStatusPreferences = candidate.jobStatusPreferences;
  }
  if (candidate.jobTypePreferences) {
    newFormData.candidate.jobTypePreferences = candidate.jobTypePreferences;
  }
  if (candidate.occupationPreferences) {
    newFormData.candidate.occupationPreferences = candidate.occupationPreferences;
  }
  if (candidate.locationPreferences && candidate.locationPreferences.length > 0) {
    newFormData.candidate.locationPreferences = candidate.locationPreferences;
  }
};

const setAddressFromJob = (address, job, isBasicApplication = false) => {
  address.countryCode = job && job.address ? job.address.countryCode : "US";
  address.region = job && job.address && job.address.admin1Name !== null ? job.address.admin1Name : "";
  address.placeName = job && job.address ? job.address.placeName : "Default";
  address.postalCode = job && job.address ? job.address.postalCode : "Default";
  address.admin1Code = job && job.address && job.address.admin1Code !== null ? job.address.admin1Code : "";
  address.admin1Name =
    job && job.address && job.address.admin1Name !== null
      ? job.address.admin1Name
      : isBasicApplication
      ? ""
      : "Default"; //Fixed 8230
  return address;
};

const initializeAddress = (address, job, isBasicApplication = false) => {
  if (address) {
    if (!address.countryCode) {
      address = setAddressFromJob(address, job, isBasicApplication);
    }
  } else {
    address = {};
    address = setAddressFromJob(address, job, isBasicApplication);
  }
  return address;
};

const getSkills = (newFormData, candidate) => {
  if (newFormData.skills && newFormData.skills !== "") {
    return newFormData.skills;
  } else {
    return candidate.skills && candidate.skills !== "undefined" ? candidate.skills : "";
  }
};

export const prePopulateDataFromCandidate = (formData, job, candidate, isBasicApplication = false) => {
  let newFormData = cloneDeep(formData);
  if (candidate && typeof candidate !== "undefined" && candidate !== null) {
    newFormData.firstName = candidate.firstName;
    newFormData.lastName = candidate.lastName;
    newFormData.email = candidate.email;
    newFormData.confirmEmail = candidate.email;
    if (!isBasicApplication) {
      newFormData.skills = getSkills(newFormData, candidate);
    }
    newFormData.executiveSummary =
      newFormData.executiveSummary !== ""
        ? newFormData.executiveSummary
        : candidate.executiveSummary && candidate.executiveSummary !== "undefined"
        ? candidate.executiveSummary
        : "";
    newFormData.noticePeriod =
      newFormData.noticePeriod !== ""
        ? newFormData.noticePeriod
        : candidate.noticePeriod && candidate.noticePeriod !== "undefined"
        ? candidate.noticePeriod
        : "";
    newFormData.candidateId = candidate.id;

    if (!newFormData.candidate) {
      newFormData.candidate = {};
    }

    if (!isBasicApplication) {
      setJobPreferences(newFormData, candidate);
    }

    if (!newFormData.id) {
      // if add pre-fill by profile
      newFormData = Object.assign(newFormData, candidate);
      //remove ids
      delete newFormData.id;
      if (newFormData.address) {
        let cloneAddress = Object.assign({}, newFormData.address);
        delete cloneAddress.id;
        newFormData.address = cloneAddress;
        // delete newFormData.address.id;
      }
      if (Array.isArray(newFormData.employment)) {
        let newEmploymet = [];
        newFormData.employment.forEach(function (employment) {
          let employmentWithOutId = cloneDeep(employment);
          delete employmentWithOutId.id;
          newEmploymet.push(employmentWithOutId);
        });
        newFormData.employment = newEmploymet;
      }
      if (Array.isArray(newFormData.qualification)) {
        let newQualification = [];
        newFormData.qualification.forEach(function (qualification) {
          let qualificationWithOutId = cloneDeep(qualification);
          delete qualificationWithOutId.id;
          newQualification.push(qualificationWithOutId);
        });
        newFormData.qualification = newQualification;
      }
      //override property diff
      //newFormData.applicationMessage = newFormData.applicationMessage;
    }

    if (candidate.cv && !candidate.cv.upload) {
      let cv = Object.assign({}, candidate.cv);
      cv.upload = candidate.cv.id;
      newFormData.candidate.cv = cv;
      newFormData.cv = cv;
      // newFormData.candidate.cv.upload = candidate.cv.id;
    }
  }
  newFormData.address = initializeAddress(newFormData.address, job, isBasicApplication);

  return newFormData;
};

export const setCvAndCoverletterRequiredOrOptional = (job, schema) => {
  const resumeRequired = job?.isResumeCompulsory;
  const coverletterRequired = job?.coverletterCompulsory;
  if (resumeRequired && schema.definitions["requiredDocument"].required.length <= 0) {
    schema.definitions["requiredDocument"].required.push("upload");
  }
  if (coverletterRequired && schema.definitions["requiredCoverletter"].required.length <= 0) {
    schema.definitions["requiredCoverletter"].required.push("upload");
  }

  const newSchema = Immutable.fromJS(schema)
    .set("definitions", {
      ...schema.definitions,
    })
    .updateIn("required".split(","), (arr) => {
      if (resumeRequired && arr.indexOf("cv") < 0) {
        return arr.push("cv");
      } else if (!resumeRequired && arr.indexOf("cv") > -1) {
        return arr.splice(arr.indexOf("cv"), 1);
      } else if (coverletterRequired && arr.indexOf("coverLetter") < 0) {
        return arr.push("coverLetter");
      } else if (!coverletterRequired && arr.indexOf("coverLetter") > -1) {
        return arr.splice(arr.indexOf("coverLetter"), 1);
      } else {
        return arr;
      }
    })
    .toJS();
  if (newSchema.properties.firstName.minLength.length > 1) {
    newSchema.properties.firstName.minLength = schema.properties.firstName.minLength;
    newSchema.properties.lastName.minLength = schema.properties.lastName.minLength;
  }
  return newSchema;
};

export const getLastMandatoryStep = (steps) => {
  let lastStep = 0;
  let counter = 0;
  if (steps && steps.length > 0) {
    steps.map((step) => {
      if (step.required === true) {
        lastStep++;
      }
      counter++;
    });
    return lastStep;
  }

  return -1;
};

export const setParsedAddress = (parsedAddress, address) => {
  if (parsedAddress !== null && parsedAddress.admin1Code !== "Default" && address.admin1Name === "Default") {
    return parsedAddress;
  } else {
    return address;
  }
};

export const checkJobExpiredAndApplicationAllowed = (job, newFormData, history) => {
  const currentDate = new Date();
  let expiryDate = new Date(job?.jobAdvertExpiryDate);
  expiryDate.setDate(expiryDate.getDate() + 30);

  if (
    (job?.expired && !job?.allowApplicationsAfterExpiry) ||
    (job?.expired && job?.allowApplicationsAfterExpiry && expiryDate < currentDate) ||
    (job?.expired &&
      job?.allowApplicationsAfterExpiry &&
      expiryDate > currentDate &&
      !Object.prototype.hasOwnProperty.call(newFormData, "imported")) ||
    (job?.expired &&
      job?.allowApplicationsAfterExpiry &&
      Object.prototype.hasOwnProperty.call(newFormData, "imported") &&
      !newFormData.imported)
  ) {
    history.push("/404.html");
  }
};

export const highlightRequiredQuestions = () => {
  const formSubmitButton = document.getElementsByClassName("sv_complete_btn");

  if (formSubmitButton && formSubmitButton.length > 0) {
    formSubmitButton[0].click();
  }
};
